import React from 'react';

export default function Merch() {
  return (
    <div className="page">
      <h1 className="page-title">Merch</h1>
      <div className="merch-coming-soon">
        <div style={{ fontSize: '3rem', marginBottom: 16 }}>&#x1F6CD;&#xFE0F;</div>
        <h2>Coming Soon</h2>
        <p>Train Daily merch is on the way. Stay tuned!</p>
      </div>
    </div>
  );
}
